module.exports = __webpack_public_path__ + "img/9类杂项.e3a638f7.png";